const audienceFilter = document.querySelector("[data-audience-filter]")

if (!!audienceFilter) {
	audienceFilter.addEventListener("change", function(e) {
		e.preventDefault()
		window.location.href = this.options[this.selectedIndex].value
	})
}

import 'choices.js';
import FormValidator from './FormValidator';

let eventSubmissionForm = document.querySelector('#event-submission-form');
if (eventSubmissionForm) {
	let validator = new FormValidator([
		/* Rule can be [key, errorMessage, validator(){...}, elementToScrollTo] */
		['eventTitle', 'The event name is required.', formData => !!formData.get('title'), '[data-form-field-title]'],
		['eventsPrimaryCategory', 'The event category is required.', formData => !!formData.get('eventsPrimaryCategory[]'), '[data-form-field-eventsPrimaryCategory]'],
		['township', 'The event township is required.', formData => !!formData.get('township[]'), '[data-form-field-township]'],
		['eventsDescription', 'The event description is required.', formData => !!formData.get('eventsDescription'), '[data-form-field-eventsDescription]'],
		['featureImage', 'The event image is required.', formData => !!formData.get('featureImage'), '[data-form-field-featureImage]'],
		[
			'eventDates', 'At least one event date is required.', formData => {
			let eventDates = JSON.parse(formData.get('eventDates'));
			return !!eventDates.eventOccurrences.length;
		}, '.eventdates'
		],
		[
			'eventsVenue', 'The event venue is required. You can either select from the list or enter it manually', formData => {
			let isVenueManual = formData.get('isVenueManual');
			if (isVenueManual) {
				return (formData.get('eventsVenueManualAddress1') && formData.get('eventsVenueManualSuburb') && formData.get('eventsVenueManualPostcode')) || formData.get('contactGeolocation');
			} else {
				return !!formData.get('eventsVenue[]');
			}
		}, '[data-form-field-eventsVenue]'
		],
		['contactName', 'The event contact is required.', formData => !!formData.get('contactName'), '[data-form-field-contactName]'],
		['contactEmailAddress', 'The event contact email is required.', formData => !!formData.get('contactEmailAddress'), '[data-form-field-contactEmailAddress]'],
		['contactWebsite', 'Url should start with https:// or http://.', formData => !formData.get('contactWebsite') || formData.get('contactWebsite').match(/^http[s]*:\/\//), '[data-form-field-contactWebsite]'],
		['contactSocialMedia', 'Url should start with https:// or http://.', formData => !formData.get('contactSocialMedia') || formData.get('contactSocialMedia').match(/^http[s]*:\/\//), '[data-form-field-contactSocialMedia]'],
		['eventsOnlineTicketingLink', 'Url should start with https:// or http://.', formData => !formData.get('eventsOnlineTicketingLink') || formData.get('eventsOnlineTicketingLink').match(/^http[s]*:\/\//), '[data-form-field-eventsOnlineTicketingLink]'],
	], eventSubmissionForm);
}